import { ThemeProjectNeritClin } from 'submodules/neritclin-components-ui/theme/project/white-labels/ThemeProjectNeritClin'
import { ThemeProjectLisoLaser } from 'submodules/neritclin-components-ui/theme/project/white-labels/ThemeProjectLisoLaser'

const domain = window.location.pathname.split('/')[1];
const isLisoLaser = (domain === 'lisolaser' || domain === 'lisolaser_dev')

export const ThemeProject = isLisoLaser ? ThemeProjectLisoLaser : ThemeProjectNeritClin;
